import Vue from 'vue'
import Router from 'vue-router'
// 首页
const index = () => import('@/pages/register/index');
// 鱼泡
const strategy = () => import('@/pages/strategy/index');
// 拼团福利
const group = () => import('@/pages/group/index');
// 规则说明
const rule = () => import('@/pages/rule/index');
// 规则说明
const simulatedEducationRule = () => import('@/pages/simulatedEducationRule/index');
// 规则说明支付
const ruleDescription = () => import('@/pages/ruleDescription/index');
// 用户协议
const userAgreement = () => import('@/pages/userAgreement/index');
// 隐私政策
const privacyPolicy = () => import('@/pages/privacyPolicy/index');
// 合伙人分享页面
const partnerShare = () => import('@/pages/partnerShare/index');
// 邀请注册分享页面
const InviteRegister = () => import('@/pages/InviteRegister/index');
// 注册页面
const register = () => import('@/pages/register/index');
// 注册成功,引导下载
const registerSucess = () => import('@/pages/registerSucess/index');
// 下载页
const download = () => import('@/pages/download/index');
// 直播抽奖
const liveLottery = () => import('@/pages/liveLottery/index');
// 抽奖规则
const ruleLottery = () => import('@/pages/ruleLottery/index');
// 历史记录
const history = () => import('@/pages/history/index');
// 历史详情
const historyDetail = () => import('@/pages/historyDetail/index');
Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/strategy',
      name: 'strategy',
      component: strategy
    },
    {
      path: '/group',
      name: 'group',
      component: group
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    {
      path: '/simulatedEducationRule',
      name: 'simulatedEducationRule',
      component: simulatedEducationRule
    },
    {
      path: '/ruleDescription',
      name: 'ruleDescription',
      component: ruleDescription
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement,
      meta:{
        title:"用户协议"
      }
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy,
      meta:{
        title:"隐私协议"
      }
    },
    {
      path: '/partnerShare',
      name: 'partnerShare',
      component: partnerShare
    },
    {
      path: '/InviteRegister',
      name: 'InviteRegister',
      component: InviteRegister
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/registerSucess',
      name: 'registerSucess',
      component: registerSucess
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/liveLottery',
      name: 'liveLottery',
      component: liveLottery
    },
    {
      path: '/ruleLottery',
      name: 'ruleLottery',
      component: ruleLottery,
      meta:{
        title:"抽奖规则"
      }
    },
    {
      path: '/history',
      name: 'history',
      component: history,
      meta:{
        title:"历史记录"
      }
    },
    {
      path: '/historyDetail',
      name: 'historyDetail',
      component: historyDetail,
      meta:{
        title:"历史详情"
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js